import { Button, Typography, Box } from '@mui/material';

import Grid from 'components/core/Grid';
import { ContentSection, SaleDate } from './styles';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';

import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { Link } from '@mui/material';
import ConfirmationDialog from 'components/core/ConfirmationDialog/ConfirmationDialog';
import { useToggle } from '@alluradirect/react';
import { bigWhitePerk } from 'config/imageUrls';


export const HeroHeader = ({ openModal }: { openModal: () => void; }) => {

  const termsToggle = useToggle();

  return (
    <>
      <ContentSection>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6} lg={7}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <Typography variant="h1" color={'primary'}>
                  Big White Winter Season Pass Perk
                </Typography>
                <Typography variant="h3" color={'secondary'} sx={{ marginTop: '8px' }}>
                  Up to $100.00 Accommodation Credit
                </Typography>

              </Grid>
              <Grid item xs={12}>
                <Typography>
                  Passholders for the 2026/2027 winter season receive up to $100.00 CAD off on any Big White vacation rental on alluraDirect.com <br /><br />
                  <strong>Buy your season pass early to save more...</strong><br />
                  <Box my={2}>
                    <SaleDate mb={1}><LocalOfferIcon color="secondary" /> <div><strong>$100.00</strong>&nbsp;- Early Bird (Ends Oct 19, 2026)</div></SaleDate>
                    <SaleDate mb={1}><LocalOfferIcon color="secondary" /> <div><strong>$100.00</strong>&nbsp;- Pre-Season (Ends Nov 27, 2026)</div></SaleDate>
                    <SaleDate><LocalOfferIcon color="secondary" /> <div><strong>$50.00</strong>&nbsp;- In-Season (Starts Nov 28, 2026)</div></SaleDate>
                  </Box>

                  Valid for arrivals between December 1, 2026 - March 31, 2027. <Link color="secondary" sx={{ cursor: 'pointer' }} onClick={termsToggle.open}>View terms of usage...</Link>
                </Typography>
              </Grid>
              <Grid item xs={12}>
                <Button variant="contained" color="secondary" size="large" fullWidth onClick={openModal} endIcon={<ChevronRightIcon />}>
                  Claim Your Perk Now
                </Button>

              </Grid>
            </Grid>
          </Grid>
          <Grid item xs={12} md={6} lg={5}>
            <img style={{ width: '100%' }} src={bigWhitePerk} />
            <Link color="secondary" sx={{ display: 'block', width: '100%', textAlign: 'center' }} href="https://www.bigwhite.com/season-passes?utm_source=alluraDirect&utm_medium=alluraUniversal&utm_campaign=alluraUniversal&utm_id=alluraPerk&utm_term=alluraUniversal&utm_content=alluraUniversal" target="_blank">Haven&apos;t bought your pass yet?  Click Here</Link>
          </Grid>
        </Grid>
      </ContentSection >

      <ConfirmationDialog
        dialogTitle="Terms of usage..."
        isDialogOpen={termsToggle.isOpen}
        handleCloseDialog={termsToggle.close}
        hasBottomBar={false}
        hasHeaderBar={true}
        padding={0}
        maxWidth="sm"
        isFullScreen={false}
      >
        <Grid container>
          <Grid item xs={12} p={1}>
            <Grid container>
              <Grid item xs={12}>
                <Typography variant="body1">
                  <ul>
                    <li>New reservations only.</li>
                    <li>Credit is valid for dates between December 1, 2026 - March 31, 2027</li>
                    <li>Available on Senior and Adult season passholder purchases.</li>
                    <li>Max 1 season pass perk can be applied, per account, per season.</li>
                    <li>The value of the credit is based on the purchase date of the season pass from BigWhite.com
                      <ul>
                        <li>$100.00 CAD until October 19, 2026</li>
                        <li>$100.00 CAD until November 27, 2026</li>
                        <li>$50.00 CAD after November 27th, 2026</li>
                      </ul>
                    </li>
                  </ul>
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </ConfirmationDialog>
    </>
  );
};
